import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
// import AnimatedNumbers from 'react-animated-numbers';
import { PieChart } from 'components/charts';
// import ProgressBar from 'components/ProgressBar';
// import { useAuth } from 'hooks';
// import GetPercentage from 'components/common/GetPercentage';
// import { userLogout } from 'store/authSlice';
import { numberWithCommas } from 'utils/NumberCommaSeprator';
import { LoadingAnimation } from 'components/common';

// const getDashboardURL = process.env.REACT_APP_FAST_API_URL;

const CardContainer = styled(Card)`
	height: 100%;
	display: flex;
	align-items: top;
	justify-content: space-between;
	.ant-card-body {
		width: 100%;
	}
`;

const TripCompletedWrapper = styled.div`
	margin-bottom: 16px;
`;

const TripTitle = styled.div`
	font-size: 16px;
	font-weight: 600;
`;

const EstimatedToolCost = styled.div`
	gap: 6px;
	font-size: 26px;
	margin-top: 16px;
	font-weight: 700;
	display: inline-flex;
	fontfamily: 'Montserrat';
`;

// const DefinedCount = styled.div`
// 	gap: 6px;
// 	display: inline-flex;
// `;

// const DefinedCountPercentage = styled.div`
// 	gap: 6px;
// 	font-size: 20px;
// 	font-weight: 700;
// 	display: inline-flex;
// `;

// const TripProgress = styled.div`
// 	margin: 12px 0;
// 	max-width: 180px;
// `;

// const RegularProgress = styled.div`
// 	margin: 6px 0;
// 	max-width: 180px;
// `;

const HrLine = styled.div`
	background: #f4f4f0;
	height: 2px;
	margin: 36px 0;
	overflow: hidden;
`;

const RegularTripTitle = styled.div`
	color: #7660fa;
	position: relative;
	padding-right: 16px;
	display: inline-flex;
	align-items: center;
	&:after {
		content: '';
		width: 10px;
		height: 7px;
		position: absolute;
		right: 0;
		background: #7660fa;
	}
`;

const RegularEstimatedCost = styled.div`
	gap: 6px;
	font-size: 16px;
	font-weight: bold;
	display: inline-flex;
`;

// const RegularEstimatedCostCount = styled.div`
// 	gap: 6px;
// 	font-weight: 700;
// 	display: inline-flex;
// `;

const AdhocTripTitle = styled.div`
	color: #f27e9b;
	position: relative;
	padding-right: 16px;
	display: inline-flex;
	align-items: center;
	&:after {
		content: '';
		width: 10px;
		height: 7px;
		position: absolute;
		right: 0;
		background: #f27e9b;
	}
`;

const EmptyCircle = styled.div`
	width: 300px;
	height: 300px;
	border-radius: 50%;
	background: rgb(225, 225, 225);
	display: flex;
	align-items: center;
	font-size: 30px;
	justify-content: center;
	font-weight: 500;
`;

const dummyData = [
	{
		total: 0,
		completed: 1,
		estimated_cost: 0,
	},
	{
		total: 0,
		completed: 1,
		estimated_cost: 0,
	},
];

function TripCompleted({ completed, isLoading }) {
	const [tripData, setTripData] = useState();
	const [pieChartName, setPieChartName] = useState();
	const [pieData, setPieData] = useState(dummyData);

	useEffect(() => {
		setTripData(0);
		setPieChartName(null);
		setPieData(dummyData);
		if (completed) {
			if (
				completed.regular_trips_summary.total > 0 &&
				completed.adhoc_trips_summary.total > 0
			) {
				setPieData([completed.regular_trips_summary, completed.adhoc_trips_summary]);
				setPieChartName('both');
				setTripData(completed);
			} else if (completed.adhoc_trips_summary.total > 0) {
				setPieData([completed.adhoc_trips_summary]);
				setPieChartName('adhoc');
				setTripData(completed);
			} else if (completed.regular_trips_summary.total > 0) {
				setPieData([completed.regular_trips_summary]);
				setPieChartName('regular');
				setTripData(completed);
			} else {
				setPieData(dummyData);
				setTripData(null);
			}
		}
	}, [completed]);

	return (
		<CardContainer>
			{isLoading ? (
				<div style={{ width: '200px', height: '200px', margin: '150px auto' }}>
					<LoadingAnimation visible={isLoading} animationID="TripCompleted" />
				</div>
			) : (
				<>
					<Row>
						<Col flex={2}>
							<>
								<TripCompletedWrapper>
									<TripTitle>Trips Completed</TripTitle>
									<div
										style={{
											fontSize: '38px',
											fontWeight: 700,
											fontFamily: 'Montserrat',
										}}
									>
										{numberWithCommas(tripData?.completed_trips)}
									</div>
									{/* <AnimatedNumbers
										includeComma
										transitions={() => ({
											type: 'spring',
											duration: 1,
										})}
										animateToNumber={tripData?.completed_trips}
										fontStyle={{
											fontSize: '38px',
											fontWeight: 700,
											fontFamily: 'Montserrat',
										}}
									/> */}
								</TripCompletedWrapper>
								{/* <div>
									<DefinedCountPercentage>
										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 1,
											})}
											animateToNumber={GetPercentage(
												tripData?.completed_trips,
												tripData?.total_trips
											)}
										/> *
										{GetPercentage(
											tripData?.completed_trips,
											tripData?.total_trips
										)}
										%
									</DefinedCountPercentage>
									<TripProgress>
										<ProgressBar
											percentage={GetPercentage(
												tripData?.completed_trips,
												tripData?.total_trips
											)}
										/>
									</TripProgress>
									<DefinedCount>
										Defined Trips Count:
										{tripData?.total_trips}
										{/* <div
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 0.5,
											})}
											animateToNumber={tripData?.total_trips}
										/> *
									</DefinedCount>
								</div> */}
								<div>
									<EstimatedToolCost>
										₹{' '}
										{tripData?.total_estimated_cost
											? numberWithCommas(tripData?.total_estimated_cost)
											: 0}
										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 0.2,
											})}
											animateToNumber={tripData?.total_estimated_cost}
											fontStyle={{
												fontSize: '32px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										/> */}
									</EstimatedToolCost>
									<div>Estimated Total Cost</div>
								</div>
							</>
						</Col>
						<Col style={{ display: 'flex', justifyContent: 'flex-end' }} flex={2}>
							{tripData?.completed_trips > 0 ? (
								<div style={{ width: '300px' }}>
									<PieChart chartName={pieChartName} chartData={pieData} />
								</div>
							) : (
								<div style={{ width: '300px' }}>
									<EmptyCircle>0%</EmptyCircle>
								</div>
							)}
						</Col>
					</Row>
					<HrLine />
					<Row gutter={16}>
						<Col flex={2}>
							<div>
								<div>
									<RegularTripTitle>Regular Trips</RegularTripTitle>
									<div
										style={{
											fontSize: '20px',
											fontWeight: 700,
											fontFamily: 'Montserrat',
										}}
									>
										{numberWithCommas(
											tripData?.regular_trips_summary?.completed
										)}
									</div>
									{/* <AnimatedNumbers
										includeComma
										transitions={() => ({
											type: 'spring',
											duration: 1,
										})}
										animateToNumber={tripData?.regular_trips_summary?.completed}
										fontStyle={{
											fontSize: '20px',
											fontWeight: 700,
											fontFamily: 'Montserrat',
										}}
									/> */}
								</div>
								<div style={{ marginTop: '16px' }}>
									<RegularEstimatedCost>
										₹
										<div
											style={{
												fontSize: '16px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										>
											{tripData?.regular_trips_summary?.estimated_cost
												? numberWithCommas(
														tripData?.regular_trips_summary
															?.estimated_cost
												  )
												: 0}
										</div>
										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 0.2,
											})}
											animateToNumber={
												tripData?.regular_trips_summary?.estimated_cost
											}
											fontStyle={{
												fontSize: '16px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										/> */}
									</RegularEstimatedCost>
									<div>Estimated Cost</div>
								</div>
								{/* <div style={{ marginTop: '16px' }}>
									<RegularEstimatedCostCount>
										<div
											style={{
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										>
											{GetPercentage(
												tripData?.regular_trips_summary?.completed,
												tripData?.regular_trips_summary?.total
											)}
										</div>
										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 1,
											})}
											animateToNumber={GetPercentage(
												tripData?.regular_trips_summary?.completed,
												tripData?.regular_trips_summary?.total
											)}
											fontStyle={{
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										/> *
										%
									</RegularEstimatedCostCount>
									<RegularProgress>
										<ProgressBar
											height={4}
											percentage={GetPercentage(
												tripData?.regular_trips_summary?.completed,
												tripData?.regular_trips_summary?.total
											)}
										/>
									</RegularProgress>
									<DefinedCount>
										Defined Trips Count
										{tripData?.regular_trips_summary?.total}
										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 1,
											})}
											animateToNumber={tripData?.regular_trips_summary?.total}
										/> *
									</DefinedCount>
								</div> */}
							</div>
						</Col>
						<Col flex={2}>
							<div>
								<div>
									<AdhocTripTitle>Adhoc Trips </AdhocTripTitle>
									<div>
										<div
											style={{
												fontSize: '20px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										>
											{numberWithCommas(
												tripData?.adhoc_trips_summary?.completed
											)}
										</div>

										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 1,
											})}
											animateToNumber={
												tripData?.adhoc_trips_summary?.completed
											}
											fontStyle={{
												fontSize: '20px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										/> */}
									</div>
								</div>
								<div style={{ marginTop: '16px' }}>
									<RegularEstimatedCost>
										₹
										<div
											style={{
												fontSize: '16px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										>
											{tripData?.adhoc_trips_summary?.estimated_cost
												? numberWithCommas(
														tripData?.adhoc_trips_summary
															?.estimated_cost
												  )
												: 0}
										</div>
										{/* <AnimatedNumbers
											includeComma
											transitions={() => ({
												type: 'spring',
												duration: 0.2,
											})}
											animateToNumber={
												tripData?.adhoc_trips_summary?.estimated_cost
											}
											fontStyle={{
												fontSize: '16px',
												fontWeight: 700,
												fontFamily: 'Montserrat',
											}}
										/> */}
									</RegularEstimatedCost>
									<div>Estimated Cost</div>
								</div>
							</div>
						</Col>
					</Row>
				</>
			)}
		</CardContainer>
	);
}

TripCompleted.propTypes = {
	completed: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default TripCompleted;
